import { Box, Paper, PaperProps, Typography } from "@mui/material";
import i18n from "i18next";

export function GooglePlacesAutocompletePaper(props: PaperProps) {
	const { children, ...other } = props;

	return (
		<Paper {...other}>
			{children}
			<Box
				sx={{
					borderTop: 1,
					borderColor: "divider",
					display: "flex",
					justifyContent: "flex-end",
					px: 1.5,
					py: 0.75,
				}}
			>
				<Typography
					variant={"caption"}
					sx={{
						color: "text.secondary",
						fontWeight: 500,
					}}
				>
					{i18n.t("powered_by_google")}
				</Typography>
			</Box>
		</Paper>
	);
}
